'use client';

import { useTranslations } from 'next-intl';
import { BaseLineExclamation } from '@/app/components/icons/BaseLineExclamation';
import { useStore } from '@/app/providers/store';

export const TeamPlanExpiredBanner = () => {
  const t = useTranslations();
  const { hasUserId, isTeamSpace, isSubscriptionInitialized, activeTeamBundleProduct } = useStore((state) => ({
    hasUserId: Boolean(state.userInfo?.id),
    isTeamSpace: state.isTeamSpace,
    isSubscriptionInitialized: state.isSubscriptionInitialized,
    activeTeamBundleProduct: state.activeTeamBundleProduct,
  }));

  if (!hasUserId || !isTeamSpace || !isSubscriptionInitialized || activeTeamBundleProduct) return null;

  const tipText = t('payments.mySubscription.teamPlanExpiredTip');

  return (
    <div className="border-[#5A4720] border-b bg-[#2A210F] px-4 py-2.5 text-[#FFE7A6] sm:px-3">
      <div className="mx-auto flex max-w-[2336px] items-center justify-center gap-2">
        <div className="flex min-w-0 items-center justify-center gap-2">
          <BaseLineExclamation className="size-4 shrink-0 text-[#F5C55A]" />
          <span className="text-center text-sm">{tipText}</span>
        </div>
      </div>
    </div>
  );
};
